import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import VM from 'scratch-vm';

import defaultCostumeTags from '../lib/libraries/sprite-tags';
import LibraryComponent from '../components/library/library.jsx';
import {loadLibraryTags} from '../lib/library-tags';
import {
    loadScratchResources,
    SCRATCH_RESOURCE_PAGE_SIZE
} from '../lib/scratch-resource-library';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Costume',
        description: 'Heading for the costume library',
        id: 'gui.costumeLibrary.chooseACostume'
    }
});

const RESOURCE_TYPE = 'COSTUME';
const COSTUME_TAG_DICT_CODE = 'scratch_costume_tag';

class CostumeLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelected',
            'handleRequestQuery'
        ]);
        this.state = {
            costumes: [],
            hasMore: true,
            isLoading: false,
            tags: []
        };
        this.mounted = false;
        this.requestId = 0;
    }
    componentDidMount () {
        this.mounted = true;
        loadLibraryTags(COSTUME_TAG_DICT_CODE, defaultCostumeTags)
            .then(tags => {
                if (!this.mounted) return;
                this.setState({tags});
            });
    }
    componentWillUnmount () {
        this.mounted = false;
    }
    handleItemSelected (item) {
        const vmCostume = {
            name: item.name,
            rotationCenterX: item.rotationCenterX,
            rotationCenterY: item.rotationCenterY,
            bitmapResolution: item.bitmapResolution,
            skinId: null
        };
        this.props.vm.addCostumeFromLibrary(item.md5ext, vmCostume);
    }
    handleRequestQuery (query) {
        const currentRequestId = this.requestId + 1;
        this.requestId = currentRequestId;
        const loadingState = {
            hasMore: true,
            isLoading: true
        };
        if (!query.append) {
            loadingState.costumes = [];
        }
        this.setState(loadingState);

        return loadScratchResources(query, RESOURCE_TYPE)
            .then(({hasMore, records, response}) => {
                if (currentRequestId !== this.requestId) return response;

                const nextCostumes = query.append ?
                    this.state.costumes.concat(records) :
                    records;
                this.setState({
                    costumes: nextCostumes,
                    hasMore,
                    isLoading: false
                });
                return response;
            })
            .catch(() => {
                if (currentRequestId === this.requestId) {
                    this.setState({
                        hasMore: false,
                        isLoading: false
                    });
                }
                return null;
            });
    }
    render () {
        return (
            <LibraryComponent
                data={this.state.costumes}
                hasMore={this.state.hasMore}
                id="costumeLibrary"
                isLoading={this.state.isLoading}
                pageSize={SCRATCH_RESOURCE_PAGE_SIZE}
                scopeFilterable
                tags={this.state.tags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelected}
                onRequestClose={this.props.onRequestClose}
                onRequestQuery={this.handleRequestQuery}
            />
        );
    }
}

CostumeLibrary.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(CostumeLibrary);
